<template>

	<div>
		<nav id="header" class="bg-white fixed w-full z-10 top-0 shadow px-4" style="min-height:56px">

			<div class="w-full container mx-auto flex flex-wrap items-center mt-0 pt-3 pb-3 md:pb-0">
					
				<div class="w-1/2 pl-2 md:pl-0">
					<a class="text-gray-900 text-base xl:text-xl no-underline hover:no-underline font-bold" href="#"> 
						Viral News Service
					</a>
				</div>
				<div class="w-1/2 pr-0">
					<div class="flex relative inline-block float-right">
						<router-link to="/stringer/upload" class="hidden md:block px-4 py-1 rounded bg-green-600 text-white mr-3" v-if="!userInfo.role.includes('media')">
							<i class="fas fa-upload fa-fw mr-2"></i><span class="pb-1 md:pb-0 text-sm">Upload</span>
						</router-link>
						<div class="block">
							<div class="relative text-sm">
								<button id="userButton" class="flex items-center focus:outline-none mr-3 lg:mr-0 bg-gray-300 pr-2 px-4 py-2 rounded">
									<span class="inline-block font-bold pr-1">{{ userInfo.name }}</span>
									<svg class="pl-2 h-2" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 129 129"><g><path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"/></g></svg>
								</button>
								<div id="userMenu" class="bg-white rounded shadow-md mt-2 absolute mt-12 top-0 right-0 min-w-full overflow-auto z-30 invisible">
									<ul class="list-reset">
										<li>
											<router-link to="/stringer/upload" class="block md:hidden px-4 py-2 block text-white hover:bg-gray-400 no-underline hover:no-underline bg-green-600 text-white" v-if="!userInfo.role.includes('media')">
												<i class="fas fa-upload fa-fw mr-2"></i><span class="pb-1 md:pb-0 text-sm">Upload</span>
											</router-link>
										</li>
										<li>
											<router-link to="/stringer" class="block px-4 py-2 block text-white hover:bg-gray-400 no-underline hover:no-underline text-gray-900" v-if="!userInfo.role.includes('media')">
												<span class="pb-1 md:pb-0 text-sm">Stringer Panel</span>
											</router-link>
										</li>
										<li><a href="#" class="px-4 py-2 block text-gray-900 hover:bg-gray-400 no-underline hover:no-underline">My account</a></li>
										<li><a href="#" class="px-4 py-2 block text-gray-900 hover:bg-gray-400 no-underline hover:no-underline">Notifications</a></li>
										<li><hr class="border-t mx-2 border-gray-400"></li>
										<li><a href="#" class="px-4 py-2 block text-gray-900 hover:bg-gray-400 no-underline hover:no-underline" v-on:click="performLogout()">Logout</a></li>
									</ul>
								</div>
							</div>
						</div>
						<div class="block lg:hidden flex">
							<button id="nav-toggle" class="flex items-center px-3 py-2 border rounded text-gray-500 border-gray-600 hover:text-gray-900 hover:border-blue-600 appearance-none focus:outline-none">
								<svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
							</button>
						</div>
					</div>
				</div>


				<div class="w-full flex-grow lg:flex lg:items-center lg:w-auto hidden lg:block mt-2 lg:mt-0 bg-white z-20" id="nav-content">
					<ul class="list-reset lg:flex flex-1 items-center px-4 md:px-0">
						<li class="mr-6 my-2 md:my-0">
							<router-link to="/admin/dashboard" class="block py-1 md:py-2 pl-1 align-middle text-gray-800 no-underline hover:text-gray-900 hover:text-gray-900 border-b-2 hover:border-blue-600 border-transparent" active-class="text-blue-600 border-blue-600">
								<i class="fas fa-tachometer-alt-fast fa-fw mr-2"></i><span class="pb-1 md:pb-0 text-sm">Dashboard</span>
							</router-link>
						</li>
						<li class="mr-6 my-2 md:my-0">
							<router-link to="/admin/video-manager" class="block py-1 md:py-2 pl-1 align-middle text-gray-800 no-underline hover:text-gray-900 hover:text-gray-900 border-b-2 hover:border-blue-600 border-transparent" active-class="text-blue-600 border-blue-600">
								<i class="fas fa-tv fa-fw mr-2"></i><span class="pb-1 md:pb-0 text-sm">Video Manager</span>
							</router-link>
						</li>
						<li class="mr-6 my-2 md:my-0">
							<router-link to="/admin/tools" class="block py-1 md:py-2 pl-1 align-middle text-gray-800 no-underline hover:text-gray-900 hover:text-gray-900 border-b-2 hover:border-blue-600 border-transparent" active-class="text-blue-600 border-blue-600">
								<i class="fas fa-tools fa-fw mr-2"></i><span class="pb-1 md:pb-0 text-sm">Tools</span>
							</router-link>
						</li>
						<li class="mr-6 my-2 md:my-0">
							<router-link to="/admin/users" class="block py-1 md:py-2 pl-1 align-middle text-gray-800 no-underline hover:text-gray-900 hover:text-gray-900 border-b-2 hover:border-blue-600 border-transparent" active-class="text-blue-600 border-blue-600">
								<i class="fas fa-users fa-fw mr-2"></i><span class="pb-1 md:pb-0 text-sm">Users</span>
							</router-link>
						</li>
						<li class="mr-6 my-2 md:my-0">
							<router-link to="/admin/sales/pending" class="block py-1 md:py-2 pl-1 align-middle text-gray-800 no-underline hover:text-gray-900 hover:text-gray-900 border-b-2 hover:border-blue-600 border-transparent" active-class="text-blue-600 border-blue-600">
								<i class="fas fa-badge-dollar fa-fw mr-2"></i><span class="pb-1 md:pb-0 text-sm">Sales</span>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</nav>
		<div class="w-full px-4">
			<div class="w-full container mx-auto flex flex-wrap items-center pb-3 md:pb-0 pt-16 lg:pt-24">
				<router-view class="mt-4"></router-view>
			</div>
			<PageFooter />
		</div>
	</div>

</template>

<script>

	import { EventBus } from '../../utils/events';
    import { mapActions, mapGetters } from 'vuex';
	import Navbar from '../partials/Navbar'
	import PageFooter from '../partials/PageFooter'
	import * as Config from '../../config'

	export default {
		name: 'AdminLayout',
		data () {
			return {
				chasersCount: 0,
			}
        },
		mounted() {
			
			/*Toggle dropdown list*/
			/*https://gist.github.com/slavapas/593e8e50cf4cc16ac972afcbad4f70c8*/
			var userMenuDiv = document.getElementById("userMenu");
			var userMenu = document.getElementById("userButton");
			
			var navMenuDiv = document.getElementById("nav-content");
			var navMenu = document.getElementById("nav-toggle");
			
			document.onclick = check;
			function check(e){
			var target = (e && e.target) || (event && event.srcElement);
			//User Menu
			if (!checkParent(target, userMenuDiv)) {
				// click NOT on the menu
				if (checkParent(target, userMenu)) {
				// click on the link
				if (userMenuDiv.classList.contains("invisible")) {
					userMenuDiv.classList.remove("invisible");
				} else {userMenuDiv.classList.add("invisible");}
				} else {
				// click both outside link and outside menu, hide menu
				userMenuDiv.classList.add("invisible");
				}
			}
			
			//Nav Menu
			if (!checkParent(target, navMenuDiv)) {
				// click NOT on the menu
				if (checkParent(target, navMenu)) {
				// click on the link
				if (navMenuDiv.classList.contains("hidden")) {
					navMenuDiv.classList.remove("hidden");
				} else {navMenuDiv.classList.add("hidden");}
				} else {
				// click both outside link and outside menu, hide menu
				navMenuDiv.classList.add("hidden");
				}
			}
			
			}
			function checkParent(t, elm) {
			while(t.parentNode) {
				if( t == elm ) {return true;}
				t = t.parentNode;
			}
			return false;
			}

        },
        components: {
			'navbar': Navbar,
			PageFooter,
		},
        computed: {
			...mapGetters([
                'userInfo'
            ]),
		},
		methods: {
			...mapActions([
				'logout',
				'getAuthorizationHeader',
            ]),
			performLogout() {
                this.logout().then(() => {
                    this.$router.replace('/login');
                })
			},
		}
	}
</script>